<template>
    <div>
        <Modal v-model="isShowModal" :title="title" @on-cancel="hide('formValidate')" :mask-closable="false">


            <Form ref="formValidate" :model="params" :rules="ruleValidate" label-position="top">
                <FormItem label="上传图片：" prop="hidPic">
                    <div class="j-img-echo">
                        <template v-if="!params.hidPic">
                            <Icon type="md-images" size="55" color="#c5c8ce" />
                        </template>
                        <template v-else>
                            <img :src="params.hidPic">
                        </template>
                    </div>
                    <Upload :action="action" :headers="headers" :show-upload-list="false" name="file" :on-success="uploadSuccess">
                        <Button icon="ios-cloud-upload-outline" style="width:488px">上传质检员头像</Button>
                    </Upload>
                    <Alert show-icon closable style="margin-top:10px">建议上传140*140尺寸并且大小不能大于500kb的图片</Alert>
                </FormItem>
                <FormItem label="质检员姓名：" prop="realName">
                    <Input v-model.trim="params.realName" placeholder="请输入质检员真实姓名"></Input>
                </FormItem>
                <FormItem label="账号：" prop="phone">
                    <Input v-model.trim="params.phone" placeholder="请输入质检员登录手机号"></Input>
                </FormItem>
                <FormItem label="编码：" prop="userCode">
                    <Input v-model.trim="params.userCode" placeholder="请输入质检员编码"></Input>
                </FormItem>
            </Form>


            <!-- 重写对话框底部按钮 -->
            <div slot="footer">
                <Button @click="hide('formValidate')">取消</Button>
                <Button v-if="type != 1" type="primary" @click="handleSubmit('formValidate')" :loading="loadingBtn">
                    <span v-if="!loadingBtn">确定</span>
                    <span v-else>请稍候...</span>
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isShowModal: false,
                loadingBtn: false,
                action: this.$uploadURL,
                headers: {
                    token: JSON.parse(sessionStorage.getItem('J-TOKEN')).token
                },
                title: '查看信息',
                type: 0,
                params: {
                    realName: '',
                    userCode: '',
                    hidPic: '',
                    phone: '',
                    recoveryUserId: ''
                },
                ruleValidate: {
                    realName: [
                        {required: true, message: '质检员姓名不能为空', trigger: 'change'},
                    ],
                    userCode: [
                        {required: true, message: '质检员身份证号不能为空', trigger: 'change'},
                    ],
                    hidPic: [
                        {required: true, message: '质检员头像不能为空', trigger: 'change'},
                    ],
                    phone: [
                        {required: true, message: '质检员账号不能为空', trigger: 'change'},
                    ]
                }
            }
        },
        methods: {
            // 点击提交验证
            handleSubmit(name) {
                // console.log(this.params);
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        // this.$Message.error('验证通过');
                        /**
                         * type判断
                         * 1.查看 2.新增 3.编辑
                         */
                        switch (this.type) {
                            case 1:
                                // this.title = '查看质检员';
                                break;
                            case 2:
                                // 新增质检员
                                this.addUser();
                                break;
                            case 3:
                                // 编辑质检员
                                this.updateUser();
                                break;
                            default:
                                this.$Notice.error({
                                    title: '质检员管理',
                                    desc: '查看，新增，编辑区分判断报错',
                                    duration: 0
                                });
                                break
                        }
                    } else {
                        this.$Message.error('还有信息没有填写合格哦~');
                    }
                })
            },
            // 显示模态框
            show(type, row) {
                this.isShowModal = true;
                this.type = type;
                /**
                 * type判断
                 * 1.查看 2.新增 3.编辑
                 */
                switch (type) {
                    case 1:
                        this.title = '查看质检员';
                        this.getInfo(row);
                        break;
                    case 2:
                        this.title = '新增质检员';
                        break;
                    case 3:
                        this.title = '编辑质检员';
                        this.getInfo(row);
                        break;
                    default:
                        this.$Notice.error({
                            title: '质检员管理',
                            desc: '查看，新增，编辑模态框报错',
                            duration: 0
                        });
                        break
                }
            },
            // 新增质检员
            addUser() {
                this.$Spin.show();
                this.axios.post('/recoveryUser/addUser', this.params).then(res => {
                    console.log(res);
                    setTimeout(()=>{
                        this.$Spin.hide();
                    },300);
                    if (res.status == 200) {
                        this.$emit('changeDate');
                        this.$Message.success('操作成功.');
                        this.hide('formValidate');
                    }
                    if(res.status == 201){
                        this.$Message.error(res.msg);
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '新增质检员接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 编辑质检员
            updateUser(){
                this.$Spin.show();
                this.axios.post('/recoveryUser/updateUser', this.params).then(res => {
                    console.log(res);
                    setTimeout(()=>{
                        this.$Spin.hide();
                    },300);
                    if (res.status == 200) {
                        this.$emit('changeDate');
                        this.$Message.success('操作成功.');
                        this.hide('formValidate');
                    }
                    if(res.status == 201){
                        this.$Message.error(res.msg);
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '编辑质检员接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 查询质检员详情
            getInfo(row){
                this.$Spin.show();
                this.axios.post('/recoveryUser/getInfo', {
                    recoveryUserId: row.recoveryUserId
                }).then(res => {
                    console.log(res);
                    setTimeout(()=>{
                        this.$Spin.hide();
                    },300);
                    if (res.status == 200) {
                        // this.$Message.success('操作成功.');
                        this.params.realName = res.data.realName;
                        this.params.userCode = res.data.userCode.toString();
                        this.params.hidPic = res.data.hidPic;
                        this.params.phone = res.data.phone;
                        this.params.recoveryUserId = res.data.recoveryUserId;
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '查看质检员详情接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 上传成功
            uploadSuccess(response, file, fileList){
                if (response.status == 200) {
                    this.params.hidPic = response.data;
                }
                if(response.status == 201){
                    this.$Message.error(response.msg);
                }
                if (response.status == 500) {
                    this.$Notice.error({
                        title: '服务器内部错误',
                        desc: '上传质检员接口报错',
                        duration: 0
                    });
                }
            },
            // 关闭模态框
            hide(name) {
                this.isShowModal = false;
                this.params.recoveryUserId = '';
                this.$refs[name].resetFields();
            }
        }
    }
</script>

<style scoped>

</style>